"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CALL_STATE;
(function (CALL_STATE) {
    CALL_STATE["callStatePending"] = "callStatePending";
    CALL_STATE["callStateExchangingKeys"] = "callStateExchangingKeys";
    CALL_STATE["callStateReady"] = "callStateReady";
    CALL_STATE["callStateHangingUp"] = "callStateHangingUp";
    CALL_STATE["callStateDiscarded"] = "callStateDiscarded";
    CALL_STATE["callStateError"] = "callStateError";
})(CALL_STATE = exports.CALL_STATE || (exports.CALL_STATE = {}));
